<template>
  <div>
    <aw-store v-if="selectedStore?.id" :stores="stores" :selected-store="selectedStore" />
  </div>
</template>

<script setup lang="ts">
  import { useAsyncData, useNuxtApp, useRoute } from 'nuxt/app';
  import { computed, defineAsyncComponent, ref } from 'vue';
  import { useStoresAndPetrolsStore } from '~~/common/stores/storesAndPetrolsStore';
  import { defineI18nRoute } from '#i18n';
  import { SEO_MODULE_STORE } from '~~/common/config/SeoConfig';
  import { setErrorNotification } from '~~/common/utils/helper';
  import { useSeoStore } from '~~/common/stores/seo.js';

  const AwStore = defineAsyncComponent(() => import('~~/shop/app/components/Page/Store/AwStore.vue'));

  const route = useRoute();
  const nuxtApp = useNuxtApp();
  const { $logger } = nuxtApp;

  defineOptions({
    name: 'StoresPage',
  });
  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/stores/[slug]',
      hu: '/aruhazak/[slug]',
    },
  });

  const storesAndPetrolsStore = useStoresAndPetrolsStore();
  const seoStore = useSeoStore();

  const stores = computed(() => storesAndPetrolsStore.stores);

  const dataKey = ref(`stores_${route.params.slug}`);
  const { data: storeData } = await useAsyncData(
    dataKey.value,
    async () => ({ store: await fetchStores() }),
    {
      watch: [dataKey],
      default: () => ({ store: null }),
    },
  );
  const selectedStore = computed(() => storeData.value.store);

  async function fetchStores () {
    try {
      await storesAndPetrolsStore.fetchAuchanStores();
      const newSelectedStore = storesAndPetrolsStore.stores.find(store => route.params.slug === store.slug);
      await seoStore.fetchSeoData({
        seoModule: SEO_MODULE_STORE,
        id: newSelectedStore?.id,
      });
      return newSelectedStore ?? null;
    } catch (error) {
      $logger.error(error);
      setErrorNotification({
        nuxtApp,
        error,
      });
      return null;
    }
  }
</script>
